<template>
  <div>
    <div style="height:456px;overflow: auto;">
      <div v-for="(item,index) in list" :key="index">
        <el-row type="flex" class="row-bg" justify="center" style="padding:20px 0;">
          <el-col :span="8">{{ item.shipName }}：{{ item.shipPrice | priceFilter }}</el-col>
          <el-col :span="8">本期产品货款：{{ item.shipTotal | priceFilter }}</el-col>
          <el-col :span="8">预计时间：{{ item.shipPayDate }}</el-col>
        </el-row>
        <el-table
          border
          ref="tableRef"
          :data="item.orderContractShipmentContentVoList"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          empty-text="产品已全部移入备货区！"
          @row-dblclick="dblclickW"
          @select="stepsListRowClick"
          @select-all="selectAll"
          @selection-change="selectChange(index)"
        >
          <el-table-column fixed type="selection" width="35"></el-table-column>
          <el-table-column prop="brandName" label="品牌" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="proType" label="型号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderNumber" label="订货号" min-width="90" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cbExtimeValue" label="货期">
            <template slot-scope="scope">{{scope.row.cbExtimeValue}}天</template>
          </el-table-column>
          <el-table-column prop="cbNumber" label="数量" min-width="50"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="join-remove-sell-btn" style="text-align: center;width:100%;">
      <el-button type="primary" @click="onRemoveAll">全部移入</el-button>
      <el-button type="primary" @click="onRemoveWholePeriod" plain>移入整期产品</el-button>
      <el-button type="primary" @click="onMoveInStockUp" plain>移入备货区</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'listFutures',
    'storageAreaList',
    'bigArray',
    'sourceType',
    'tempListFutures'
  ],
  data() {
    return {
      list: [],
      changeIndex: -1,
      storageAreaListLeft: [] // 备货区数据
    }
  },
  watch: {
    listFutures: {
      handler(newVal) {
        this.list = JSON.parse(JSON.stringify(newVal))
      },
      deep: true
    },
    storageAreaList: {
      handler(newVal) {
        this.storageAreaListLeft = newVal
      },
      deep: true
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 待备货产品
    stepsListRowClick(selection, row) {
      row.isChecked = !row.isChecked
    },
    // 全选
    selectAll(selection) {
      if (selection.length > 0) {
        if (selection.length > 0) {
          selection.forEach((item) => {
            item.isChecked = true
          })
        }
      } else {
        // 取消全选是找到全选的列表下标
        for (let i = 0; i < this.list.length; i++) {
          if (this.changeIndex === i) {
            this.list[i].orderContractShipmentContentVoList.forEach((item) => {
              item.isChecked = false
            })
          }
        }
      }
    },
    // 用来取消全选是找到全选的列表下标
    selectChange(index) {
      this.changeIndex = index
    },
    dblclickW(row) {
      row.isChecked = true
      this.onMoveInStockUp()
    },
    // 移入全部
    onRemoveAll() {
      for (let i = 0; i < this.list.length; i++) {
        for (
          let j = 0;
          j < this.list[i].orderContractShipmentContentVoList.length;
          j++
        ) {
          const model = this.list[i].orderContractShipmentContentVoList
          model[j].isChecked = true
        }
      }
      this.onMoveInStockUp()
    },
    // 移入整期产品
    onRemoveWholePeriod() {
      for (let i = 0; i < this.list.length; i++) {
        const model = this.list[i].orderContractShipmentContentVoList
        if (model.some((ele) => ele.isChecked === true)) {
          model.forEach((res) => {
            res.isChecked = true
          })
        }
      }
      this.onMoveInStockUp()
    },
    // 移入备货区
    onMoveInStockUp() {
      let isFalse = true
      for (let i = 0; i < this.list.length; i++) {
        if (
          this.list[i].orderContractShipmentContentVoList.some(
            (ele) => ele.isChecked
          )
        ) {
          isFalse = false
          break
        }
      }
      if (isFalse) {
        this.$message.error('请选中产品！')
        return
      }
      const dataList = []
      for (let i = 0; i < this.list.length; i++) {
        for (
          let j = 0;
          j < this.list[i].orderContractShipmentContentVoList.length;
          j++
        ) {
          const model = this.list[i].orderContractShipmentContentVoList[j]
          if (model.isChecked === true) {
            const obj = {
              deliveryId: i,
              sourceId: model.sourceId,
              sourceType: this.sourceType,
              stockupCount: model.cbNumber,
              maxCount: model.maxCount,
              id: model.csId
            }
            model.orderContractStockupContentSourceList = []
            model.orderContractStockupContentSourceList.push(obj)
            dataList.push(model)
            this.list[i].orderContractShipmentContentVoList.splice(j, 1)
            j--
          }
        }
      }
      this.$emit('getdataList', dataList)
    },
    // 移除备货区
    // onRemove (val) {
    //   val.forEach(item => {
    //     const res = this.list[item.indexParent]
    //     const newRow = JSON.parse(JSON.stringify(item))
    //     const num = item.fixedNum - item.cbNumber
    //     const arr = res.orderContractShipmentContentVoList.filter(element => {
    //       return item.id === element.id
    //     })
    //     if (arr.length !== 0) {
    //       arr.forEach(params => {
    //         params.cbNumber = params.fixedNum
    //       })
    //     } else {
    //       newRow.cbNumber = num
    //       newRow.isChecked = false
    //       res.orderContractShipmentContentVoList.splice(item.indexChildren, 0, item)
    //     }
    //   })
    // },
    // 改变备货区数量   row当前数据  old输入框老的数据  leftList左侧的数据
    onChangeNumber(val) {
      let paramsData = 1
      let data = JSON.parse(JSON.stringify(val.cbNumber))
      for (var i = 0; i < this.bigArray.length; i++) {
        for (
          let j = 0;
          j < this.bigArray[i].orderContractShipmentContentVoList.length;
          j++
        ) {
          const datas = data
          if (
            this.bigArray[i].orderContractShipmentContentVoList[j].ccId ===
              val.ccId &&
            this.bigArray[i].orderContractShipmentContentVoList[j]
              .cbExtimeValue === val.cbExtimeValue
          ) {
            if (
              val.cbNumber >=
              this.bigArray[i].orderContractShipmentContentVoList[j].cbNumber
            ) {
              for (
                let h = 0;
                h < this.list[i].orderContractShipmentContentVoList.length;
                h++
              ) {
                if (
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .ccId ===
                    this.list[i].orderContractShipmentContentVoList[h].ccId &&
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .cbExtimeValue ===
                    this.list[i].orderContractShipmentContentVoList[h]
                      .cbExtimeValue
                ) {
                  this.list[i].orderContractShipmentContentVoList.splice(h, 1)
                  h--
                }
              }
              data =
                data -
                this.bigArray[i].orderContractShipmentContentVoList[j].cbNumber
            }
            if (
              datas <
                this.bigArray[i].orderContractShipmentContentVoList[j]
                  .cbNumber &&
              paramsData === 1
            ) {
              paramsData = 2
              data = -1
              const params = JSON.parse(
                JSON.stringify(
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                )
              )
              params.cbNumber = params.cbNumber - datas
              let isData = false
              for (
                let h = 0;
                h < this.list[i].orderContractShipmentContentVoList.length;
                h++
              ) {
                if (
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .ccId ===
                    this.list[i].orderContractShipmentContentVoList[h].ccId &&
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .cbExtimeValue ===
                    this.list[i].orderContractShipmentContentVoList[h]
                      .cbExtimeValue
                ) {
                  this.list[i].orderContractShipmentContentVoList.splice(
                    h,
                    1,
                    params
                  )
                  isData = true
                }
              }
              if (!isData) {
                this.list[i].orderContractShipmentContentVoList.push(params)
              }
            }
            if (datas < 0 && paramsData === 2) {
              const params = JSON.parse(
                JSON.stringify(
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                )
              )
              let isData = false
              for (
                let h = 0;
                h < this.list[i].orderContractShipmentContentVoList.length;
                h++
              ) {
                if (
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .ccId ===
                    this.list[i].orderContractShipmentContentVoList[h].ccId &&
                  this.bigArray[i].orderContractShipmentContentVoList[j]
                    .cbExtimeValue ===
                    this.list[i].orderContractShipmentContentVoList[h]
                      .cbExtimeValue
                ) {
                  this.list[i].orderContractShipmentContentVoList.splice(
                    h,
                    1,
                    params
                  )
                  isData = true
                }
              }
              if (!isData) {
                this.list[i].orderContractShipmentContentVoList.push(params)
              }
            }
          }
        }
      }
    }
  }
}
</script>
